import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import {isUndefined} from "util";
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import { BlankSurveyDialogComponent} from "./blank-survey-dialog.component";
import { NewSurveyDialogComponent} from "./new-survey-dialog.component";
import { QuestionnaireDetail } from '../classes/questionnaireDetail';
import { QuestionnaireTemplate } from '../classes/questionnaireDetail';
declare var amplitude : any;

@Component({
  selector: 'app-select-survey-type-dialog',
  templateUrl: './surveytype.component.html',
  styleUrls: ['./surveytype.component.css']
})
export class SurveyTypeDialogComponent implements OnInit {
  qnrList: QuestionnaireDetail[];
  showLoader: boolean;
  userTemplates: QuestionnaireTemplate[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog,public SurveyTypeDialogRef: MatDialogRef<SurveyTypeDialogComponent>,private restApiService:RestApiService) {
    this.getUserTemplates();
  }

  ngOnInit() {
  }

  openDialog(type){
    let newSurveyDialogRef = this.dialog.open(BlankSurveyDialogComponent, {
      width: '800px',
      height: '54rem',
      data: {type:1,questionaire_type:type,form_type:"Master"}
    });
    newSurveyDialogRef.afterClosed().subscribe(result => {
      if(result && result.success != false){
        this.SurveyTypeDialogRef.close({success:true});
      }
      else{
        // this.SurveyTypeDialogRef.close({success:false});
      }
    });
  }

  StandardForm()
  {
    amplitude.getInstance().logEvent('StandardFormClicked');
  }
  GroupedForm()
  {
    amplitude.getInstance().logEvent('GroupedFormClicked');
  }
  
  useTemplate(type,description){
    let newSurveyDialogRef = this.dialog.open(NewSurveyDialogComponent, {
      panelClass:'custom-dialog-class',
      height : '560px',
      width: '1120px',
      data: type
    });

    newSurveyDialogRef.afterClosed().subscribe(result => {
      if (result && result.success != false) {
        this.getUserTemplates();
      }
    });
  }

  getUserTemplates() {
    let browserStorage = localStorage.getItem('browserStorage');
    if (!isUndefined(browserStorage) && browserStorage != null) {
      this.restApiService.getUserTemplates().subscribe(
        result => {
          if(result.success){
            this.userTemplates = result.result;
          }
        });
    }
  }
  
  onDiscard(){
    this.SurveyTypeDialogRef.close({success:false});
  }

}


// WEBPACK FOOTER //
// ./src/app/newSurveyDialog/surveytype.component.ts